import React from "react"
import styled from "styled-components"
import { ChatFontStyle } from "../../../../../../../../../../components/templates/chat/components/styles/chat-font-style"
import { basePosition } from "../../../../../../../../../../components/templates/chat/style"
import { EDIT_TYPE } from "../../../../../../../../types"
import BaseDraftEditor from "../../abstract/base-draft-editor"
import { Buttons } from "../../components/buttons"
import {
  CustomStyleEditor,
  EditorWrapper,
} from "../../components/custom-style-editor"
import { FullToolBar } from "../../components/tool-bar"
import { container } from "../container"

class Component extends BaseDraftEditor {
  public render() {
    const editMode = this.props.content._editMetaData.type === EDIT_TYPE.EDIT
    return (
      <>
        {editMode && (
          <StyledFullToolBar
            onChange={this.onChange}
            editorState={this.state.editorState}
          />
        )}
        <StyledEditorWrapper>
          <CustomStyleEditor
            editorState={this.state.editorState}
            onChange={this.onChange}
          />
        </StyledEditorWrapper>
        {editMode && <Buttons save={this.save} cancel={this.cancel} />}
      </>
    )
  }
}

export const MessageEditor = container(Component)

const StyledFullToolBar = styled(FullToolBar)`
  padding-left: ${basePosition}px;
`

const StyledEditorWrapper = styled(EditorWrapper)`
  margin: 10px 0 10px ${basePosition}px;
  ${ChatFontStyle.MESSAGE};
`
